import React, { PureComponent } from 'react';
import { faCaretRight, faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { APP_CONFIG } from "../../utils/config"

class Setting extends PureComponent {
    constructor(props) {
        super(props);
        this.handleClickClose = this.handleClickClose.bind(this);
        this.handelGreetingSetting = this.handelGreetingSetting.bind(this);
        this.state = {
            greetingCount : 0,
            maxCount : APP_CONFIG.maxSetting
        }
    }

    componentDidMount() {
        let greetingCount = 0
        this.props.data.greeting.map(
            (item) => item.isUse === "1" && greetingCount++
        )

        this.setState({
            ...this.state,
            greetingCount : greetingCount
        })

    }

    handleClickClose() {
        this.props.setSetting()
        this.props.close()
    }

    handelGreetingSetting(e) {
        //console.debug(e.target.value)
        if (e.target.innerText === "OFF") {
            let currentCount = this.state.greetingCount +1
            if (this.state.maxCount < currentCount) {
                // 여기에 alert
                //console.error('[Alert MAX Count]')
                this.props.alert(this.props.uiTexts.text_06)
            } else {
                this.setState({
                    ...this.state,
                    greetingCount : this.state.greetingCount + 1
                })
                // this.state.greetingCount++
                this.props.toggleGreeting(e)
            }
        } 

        if (e.target.innerText === "ON") {
            this.setState({
                ...this.state,
                greetingCount : this.state.greetingCount - 1
            })
            this.props.toggleGreeting(e)
        }
    }

    render() {
        return (
            <div className="layer_wrap layer_wrap_type">
            <div className="layer_inner">
            <div className="layer_cont">
                <h2 className="layer_h_tit"><span className="ico_comm ico_setting"></span>{this.props.uiTexts.text_02}</h2>
                <p className="layer_txt">{this.props.uiTexts.text_05}({this.state.greetingCount}/{this.state.maxCount})</p>
                <div className="message_set">
                    { this.props.data !== null && this.props.data.greeting.length > 0
                    ? <ul className="message_set_list">
                        {
                            this.props.data.greeting.map(
                                (item, index) => (
                                    <li className="message_set_item" key={index}>{item.label}
                                    <button type="button" className={item.isUse === "1" ? "btn_control is_active" : "btn_control"} value={index} onClick={this.handelGreetingSetting}>{item.isUse === "1" ? "ON" : "OFF"}</button>
                                    </li>
                                )
                            )
                        }
                        </ul>
                    : <span>{this.props.uiTexts.text_32}</span>
                    }
                </div>
                <p className="layer_txt">{this.props.uiTexts.text_06}</p>
            </div>
            <button type="button" className="btn_close"><span className="ico_comm ico_close" onClick={this.handleClickClose}>레이어 닫기</span></button> 
            </div>
            </div>
        );
    }
};

export default Setting;
